export default __webpack_public_path__ + "static/828_5-40f5cd9a7b6bffa100bbf37cae80d4bd.png";